import { useQuery } from '@apollo/react-hooks';

import { getAGGClient } from '@confluence/graphql';
import { useSessionData } from '@confluence/session-data';

import { FetchPaymentAndUpgradeStatusForTrial } from '../graphql/PaymentAndUpgradeStatusQuery.agggraphql';

export const usePaymentStatus = (skip: boolean = false) => {
	const { cloudId } = useSessionData();

	const standardOfferingKey = '2eda1119-fab4-4699-ab37-ff8f12052cde';

	const {
		data,
		error: paymentStatusError,
		loading: paymentStatusLoading,
	} = useQuery(FetchPaymentAndUpgradeStatusForTrial, {
		client: getAGGClient(),
		fetchPolicy: 'cache-and-network',
		variables: {
			cloudId,
			productKey: 'confluence.ondemand',
			offeringKey: standardOfferingKey,
		},
		skip,
	});

	const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;

	const transactionAccountAccess =
		entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethod;
	const invoiceGroupAccess =
		entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities
			?.configurePayment;

	const primaryCanPay = invoiceGroupAccess?.isAvailableToUser;
	const primaryPaymentLink = invoiceGroupAccess?.experienceUrl;

	const altCanPay = transactionAccountAccess?.isAvailableToUser;
	const altPaymentLink = transactionAccountAccess?.experienceUrl;

	const paymentUrl = primaryPaymentLink || altPaymentLink;
	const canPay = primaryCanPay || altCanPay;

	return {
		error: paymentStatusError,
		loading: paymentStatusLoading,
		canPay,
		paymentUrl,
	};
};
